import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { BaseControl } from "@cloudpivot/form/src/common/controls/base-control";
import { Switch } from '@h3/antd-vue';
let InputLogic = class InputLogic extends BaseControl {
    onChange(evt) {
        if (this.ctrl) {
            // this.ctrl.value = evt;
            this.setValue(evt);
        }
    }
};
InputLogic = tslib_1.__decorate([
    Component({
        name: "input-logic",
        components: {
            ASwitch: Switch
        }
    })
], InputLogic);
export default InputLogic;
